import { literals } from "../constants/literals";

export const formatBooleanText = (value: boolean | undefined | null) => {
  if (typeof value !== "boolean") return "-";
  return value ? literals.yes : literals.no;
};

export const formatOptionalText = (value: string | undefined | null) => {
  if (typeof value !== "string" || value.length === 0) return "-";
  return value;
};
